import React, {Component} from 'react';
import './GuestlistAddScreen.css';
import PortalScreen from "../PortalScreen";
import axios from 'axios';
import RmButton from "../../Common/RmButton";
import {Redirect} from "react-router-dom";
import ArrowLink from "../../Common/ArrowLink";
import GuestlistAddEntry from "./GuestlistAddEntry";
import ErrorMessage from "../../Common/ErrorMessage";

export default class GuestlistAddScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addEntries: [],
            errorMessage: null,
            isSaving: false,
            guestValues: { },
            redirectTo: null
        };
    }

    resetEntries() {
        let nextEntries = [];

        this.setState({
            addEntries: nextEntries
        });

        this.geaCount = 0;

        setTimeout(() => {
            this.addEntry();
            this.addEntry();
            this.addEntry();
        }, 0);
    }

    handleGuestChange(keyIdx, value) {
        let nextGuestValues = this.state.guestValues;
        nextGuestValues[keyIdx] = value;

        this.setState({
            guestValues: nextGuestValues,
            errorMessage: null
        });
    }

    addEntry() {
        let nextEntries = this.state.addEntries;
        let keyIdx = this.geaCount++;

        nextEntries.push(<GuestlistAddEntry key={"gae-" + keyIdx}
                                            onChange={this.handleGuestChange.bind(this, keyIdx)}/>);

        this.setState({
            addEntries: nextEntries
        });
    }

    componentDidMount() {
        this.resetEntries();
    }

    handleRowAddClick() {
        this.addEntry();
    }

    fireSaveRequest(continueAdding) {
        if (this.state.isSaving) {
            return;
        }

        let guestData = Object.values(this.state.guestValues);

        if (!guestData.length) {
            this.setState({
                errorMessage: "Geen gegevens ingevuld om op te slaan."
            });

            return;
        }

        this.setState({
            isSaving: true,
            errorMessage: null
        });

        let payload = {
            guests: guestData
        };

        axios.post('/guest_batch', payload)
            .then((res) => {
                if (res.data.ok) {
                    // Save OK
                    if (!continueAdding) {
                        this.setState({
                            redirectTo: "/gasten"
                        });
                    } else {
                        this.resetEntries();

                        this.setState({
                            errorMessage: "De genodigden zijn opgeslagen."
                        });
                    }
                } else {
                    // Trigger catch
                    throw new Error("Save failed: " + JSON.stringify(res.data));
                }
            })
            .catch((err) => {
                console.error('Guest batch POST, error caught:', err);

                this.setState({
                    errorMessage: "Kon de genodigden niet toevoegen. Controleer de ingevulde gegevens."
                });
            })
            .then(() => {
                this.setState({
                    isSaving: false
                });
            });

    }

    handleAddClick() {
        this.fireSaveRequest(false);
    }

    handleAddAndReloadClick() {
        this.fireSaveRequest(true);
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo}/>;
        }

        return (
            <PortalScreen tab={"gasten"} title={"Genodigden toevoegen"} subText={"Start met het invullen van de genodigdenlijst door namen toe te voegen."}
                          isLoading={this.state.isSaving}>
                <div className={"GuestlistAddScreen"}>

                    <div className={"GuestlistAddScreen__back"}>
                        <ArrowLink label={"Terug naar lijst"} routerLink={true} to={"/gasten"} reverse={true}/>
                    </div>

                    <div className={"GuestlistAddScreen__main"}>
                        <table className={"GuestlistAddScreen__table"}>
                            <thead>
                            <tr>
                                <td><strong>Voornaam</strong></td>
                                <td><strong>Achternaam</strong></td>
                                <td><strong>Categorie</strong></td>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.addEntries}
                            </tbody>
                        </table>

                        <div className={"GuestlistAddScreen__xtra"}>
                            <ArrowLink label={"Extra invoerregel toevoegen"} onClick={this.handleRowAddClick.bind(this)}/>
                        </div>

                        <div className={"GuestlistAddScreen__controls"}>
                            {this.state.errorMessage &&
                            <ErrorMessage message={this.state.errorMessage}/>
                            }

                            <RmButton label={"Toevoegen en naar lijst"} onClick={this.handleAddClick.bind(this)}
                                      busy={this.state.isSaving}/>

                            <p className={"generic"}>Detailgegevens kunnen desgewenst per persoon toegevoegd worden vanaf de genodigdenlijst.</p>
                        </div>
                    </div>

                    <div className={"GuestlistAddScreen__mobile"}>
                        <ErrorMessage message={"Deze weergave is niet beschikbaar voor de huidige schermresolutie."}/>
                    </div>
                </div>
            </PortalScreen>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Portal/Guestlist/GuestlistAddScreen.js